import Container from 'components/Container'
import ProjectCard from 'components/cards/ProjectCard'
import { PageSEO } from 'components/SEO'
import projectsData from 'data/projectsData'
import siteMetadata from 'data/siteMetadata'

export default function Projects() {
  return (
    <Container>
      <PageSEO
        title={`Projects - ${siteMetadata.title}`}
        description="Things I build when I am learning something new or just for fun."
      />
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        <div className="pt-6 pb-8 space-y-2 md:space-y-5" data-aos="zoom-in-down">
          <h1 className="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-6xl md:leading-14">
            Projects
          </h1>
          <p className="text-lg leading-7 text-gray-500 dark:text-gray-300">
            Things I build when I am learning something new or just for fun.
          </p>
        </div>
        <div className="container py-12">
          <ul className="mx-auto grid gap-10 md:grid-cols-2 lg:max-w-none">
            {projectsData.map((frontMatter, idx) => {
              return (
                <li key={idx} data-aos="fade-up" data-aos-delay={idx > 2 ? 250 : (idx + 1) * 100}>
                  <ProjectCard
                    key={frontMatter.title}
                    title={frontMatter.title}
                    description={frontMatter.description}
                    imgSrc={frontMatter.imgSrc}
                    href={frontMatter.href}
                    data-aos-delay={(idx + 1) * 200}
                    data-aos="fade-down"
                  />
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </Container>
  )
}
